import React from 'react';
import { Modal, Badge } from 'react-bootstrap';
import ArticleStatusBadge from './ArticleStatusBadge';

const ArticleDetailModal = ({ article, show, onClose }) => {
  if (!article) return null;

  const lines = (article.body || '').split('\n');
  const keywords = (article.keywords || '').split(',').filter(Boolean);

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <div>
          {/* color #a04020 (~5.8:1) — brand #e85d04 is ~3.95:1, fails AA at 11px. */}
          <div style={{ fontSize: '11px', color: '#a04020', fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: '6px' }}>
            {article.category_icon} {article.category}
          </div>
          {article.status === 'draft' && (
            <div className="d-flex align-items-center gap-2 mb-1">
              <ArticleStatusBadge status={article.status} />
              <small style={{ color: '#5a6268' }}>Not visible externally until published.</small>
            </div>
          )}
          <Modal.Title style={{ fontSize: '20px', lineHeight: 1.35 }}>
            {article.title}
          </Modal.Title>
          {article.subtitle && (
            <p className="text-muted mb-0 mt-1" style={{ fontSize: '13px', fontStyle: 'italic' }}>
              {article.subtitle}
            </p>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        {lines.map((line, i) => {
          if (!line.trim()) return <div key={i} style={{ height: '8px' }} />;
          if (line.startsWith('•')) {
            return (
              <div key={i} className="d-flex gap-2 mb-1">
                <span style={{ color: '#a04020', flexShrink: 0 }}>•</span>
                <span style={{ fontSize: '14px', color: '#333', lineHeight: 1.75 }}>{line.slice(1).trim()}</span>
              </div>
            );
          }
          return (
            <p key={i} style={{ margin: '0 0 10px', fontSize: '14px', color: '#333', lineHeight: 1.75 }}>
              {line}
            </p>
          );
        })}
        {keywords.length > 0 && (
          <div className="mt-3 pt-3 border-top d-flex flex-wrap gap-2">
            {/* color #a04020 on #fff3e0 is ~5.8:1 — #bf4f00 measures ~4.4:1 (just fails AA on Badge's small text). */}
            {keywords.map((kw, i) => (
              <Badge key={i} bg="light" text="dark" style={{ background: '#fff3e0', color: '#a04020', fontWeight: 500 }}>
                {kw.trim()}
              </Badge>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ArticleDetailModal;
